import React from 'react';
import { Federation } from "../typings";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { MdOutlineMoreVert } from "react-icons/md";
import { useNavigate } from "react-router-dom";

interface Props {
    federation: Federation;
}

function FederationRow(props: Props) {
    const navigate = useNavigate();

    return (
        <div className="box" style={{
            flexDirection: 'row' as 'row',
            padding: '12px 16px',
            width: '100%',
            alignItems: 'center'
        }}>
            <div className="drill-row-item" style={{flex: 2}}>{props.federation.id}</div>
            <div className="drill-row-item" style={{flex: 2}}>{props.federation.name}</div>
            <div className="drill-row-item" style={{flex: 1}}>{props.federation.createdAt?.split(' ')[0]}</div>
            <Menu>
                <MenuButton className="menu-button"><MdOutlineMoreVert size="24px"/></MenuButton>
                <MenuItems
                    className="menu-box"
                    anchor="bottom"
                >
                    <MenuItem>
                        <div className="menu-item" onClick={() => navigate(`/federation/${props.federation.id}`)}>
                            Edit
                        </div>
                    </MenuItem>
                </MenuItems>
            </Menu>
        </div>
    );
}

export default FederationRow;
